import React from 'react';
import CloseRounded from '@material-ui/icons/CloseRounded';
import HelpOutlineRounded from '@material-ui/icons/HelpOutlineRounded';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import ButtonBase from '@material-ui/core/ButtonBase';

import styles from './styles';
import IconButton from '../../../../../ui-components/Button/Icon';
import { withResizer, withUser } from '../../../../../HoCs';
import Component from '../../../../../ui-components/Component';
import { GrowTransition } from '../../../../../ui-components/utils';
import PropertyLinkHelp from '../../../Create/components/PropertyLinkHelp';
import { merge, setCookie, isEmptyString } from '../../../../../utils';
import view from '../../../../../Enums';
import {Link} from 'react-router-dom';
import { bold } from '../../../../../resources/styles';

class Popup extends Component {

    styles = styles;
    agents = [{ name: 'Booking.com', id: 'booking.com' }];

    state = {
        helpDialog: false,
        agents: this.agents,

        otas: [{ agent: this.agents[0], url: '' }],
    };


    submit = () => {
        setCookie('property_booking_com_url', this.state.otas[0].url, 1 / 24);
    }

    renderEarningPotential = () => {
        const potential = this.getEarningPotential();
        return potential ? <div style={this.gs('earning')}>{this.props.gc('a_few_steps')}&nbsp;<span style={this.gs('earning_highlight')}>{potential}</span>&nbsp;{this.props.gc('per_annum')}</div>
            : <div style={this.gs('earning')}>{this.props.gc('join_the_network')} &nbsp;<span style={this.gs('earning_highlight')}>25000+</span>&nbsp;{this.props.gc('owners_and_maximise')}</div>;
    }

    inputChanger = index => ({ target: { value } }) => this.setState(pState => ({ otas: pState.otas.map((_, _i) => _i !== index ? _ : { ..._, url: value }) }));
    renderInput = index => <TextField variant='outlined' size='small' style={this.gs('field')} label={this.props.gc('property_link')} value={this.state.otas[index].url} onChange={this.inputChanger(index)} InputProps={{ endAdornment: this.getWidth() < 600 ? <HelpOutlineRounded style={this.gs('adornment_icon')} onClick={this.toggleHelpDialog(true)} /> : <div style={this.gs('adornment')} onClick={this.toggleHelpDialog(true)}>{this.props.gc('how_to_find')}{'?'}</div> }} inputProps={{ style: { textOverflow: 'ellipsis' } }} />

    render = () => <div>
        <div style={this.gs('header')}>
            <div style={this.gs('title')}>{this.props.gc('listed_on_booking')}<span style={this.gs('highlight')}> {this.props.gc('start_your_journey')}</span></div>
            <IconButton size={this.getViewMode() == view.MOBILE?'small':'medium'} style={{height:'fit-content'}} onClick={this.props.onClose}><CloseRounded /></IconButton>
        </div>
        <div style={this.gs('content')}>
            {/* <div style={this.gs('content_title')}>Listed on Booking.com? Provide us the property link.</div> */}
            {this.state.otas.map((ota, index) => <div key={index} style={this.gs('ota_container')}>
                {/* <div style={this.gs('ota_heading')}>Online Travel Agent</div> */}
                {/* {this.renderAutoComplete(index)} */}
                {this.renderInput(index)}
            </div>)}
            <div style={this.gs('actions_container')}>
                <Link to={'/properties/new?auto=true'} style={this.gs('action_btn_container')}><ButtonBase style={this.gs('action')} onClick={this.submit}>{this.props.gc('fetch_details')}</ButtonBase></Link>
                <Link to={'/properties/new?skip_ota=true'} style={this.gs('action_btn_container')}><ButtonBase style={merge(this.gs('action'), { backgroundColor: '#ddd', color: '#777', minWidth: 230 })}>{this.props.gc('skip_to_fill')}</ButtonBase></Link>
            </div>
        </div>
        {this.renderEarningPotential()}
        {this.renderHelpDialog()}
    </div>;

    toggleHelpDialog = bool => () => this.setState({ helpDialog: bool });

    renderHelpDialog = () => <Dialog maxWidth='md' open={this.state.helpDialog} TransitionComponent={GrowTransition}
        fullScreen={this.getWidth() <= 700} onClose={this.toggleHelpDialog(false)}>
        <PropertyLinkHelp onClose={this.toggleHelpDialog(false)} gc={this.props.gc}/>
    </Dialog>;

}

export default withUser(withResizer(Popup));